import { defaultCountries, parseCountry, removeDialCode } from 'react-international-phone';

const DIAL_CODES = Array.from(
  new Set(defaultCountries.map((country) => parseCountry(country).dialCode)),
).sort((left, right) => right.length - left.length);

export const nationalPhoneDigits = (phone: string, dialCode?: string): string => {
  if (dialCode) {
    return removeDialCode({ phone, dialCode }).replace(/\D/g, '');
  }

  const digits = phone.replace(/\D/g, '');
  if (!digits) return '';

  const matchedCode = DIAL_CODES.find((code) => digits.startsWith(code));
  if (!matchedCode) return digits;
  if (digits === matchedCode) return '';
  return digits.slice(matchedCode.length);
};

export const hasNationalPhoneDigits = (phone: string, dialCode?: string): boolean =>
  nationalPhoneDigits(phone, dialCode).length > 0;
